import React, { useState } from 'react';
import { Collapse } from 'antd';
import AccordionItem from './AccordionItem';
import { AiOutlineSearch } from 'react-icons/ai';
import { IoIosOptions } from 'react-icons/io';
import { MdLegendToggle, MdOutlineArticle } from 'react-icons/md';
import { BiExport } from 'react-icons/bi';
import QueryArea from './QueryArea';
import Citation from './Citation';
import Export from './Export';
import LegendBar from './LegendBar';
import ViewOptions from './ViewOptions';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

const Accordion = ({ graphWrapperRef }: any) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSider = () => {
    setCollapsed((collapse) => !collapse);
  };
  return (
    <div className="flex-row md:top-0 md:right-0 w-full md:w-auto relative">
      <div
        onClick={toggleSider}
        className="hidden text-xs absolute md:flex self-start p-2 mt-4 -ml-12 mr-4 rounded-lg cursor-pointer bg-white shadow-md"
      >
        {collapsed ? <LeftOutlined /> : <RightOutlined />}
      </div>

      <div
        className={
          'flex flex-row shadow-md w-96 md:max-w-sm overflow-hidden rounded-bl-xl bg-white'
        }
        style={{
          height: '',
          display: collapsed ? 'none' : 'flex',
        }}
      >
        <Collapse className="w-96" accordion expandIconPosition="right" ghost>
          <Panel
            header={<AccordionItem title="Search" icon={AiOutlineSearch} />}
            key="1"
          >
            <QueryArea />
          </Panel>
          <Panel
            header={<AccordionItem title="View Options" icon={IoIosOptions} />}
            key="2"
          >
            <ViewOptions />
          </Panel>
          <Panel
            header={<AccordionItem title="Legend" icon={MdLegendToggle} />}
            key="3"
          >
            <LegendBar />
          </Panel>
          <Panel
            header={<AccordionItem title="Export" icon={BiExport} />}
            key="4"
          >
            <Export graphWrapperRef={graphWrapperRef} />
          </Panel>
          <Panel
            header={<AccordionItem title="Citation" icon={MdOutlineArticle} />}
            key="5"
          >
            <Citation />
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default Accordion;
